//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { Store } from '../../components/QSelectUtils.js'
import { bindTechnologicalOperationsRequiredFlags } from './Request.js'
import RequestWorkTypesList from './RequestWorkTypesList.vue'
import RequestWorkTypesPicker from './RequestWorkTypesPicker.vue'
import RequestWorkTypeRequiredIcon from './RequestWorkTypeRequiredIcon.vue'

export default {
  components: {
    RequestWorkTypesList,
    RequestWorkTypeRequiredIcon
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default () {
        return ''
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    availableWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    isContractorWorkTypes: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    isAdditionalDepartureForm: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workTypesSettingsDialogOpened: false
    }
  },
  computed: {
    workTypesSettingsBtnLabel: function () {
      return 'Обязательность выполнения'
    },
    workTypesSettingsDialogLabel: function () {
      return this.isContractorWorkTypes ? 'Настройка обязательности выполнения работ подрядчика' : 'Настройка обязательности выполнения работ'
    },
    workTypes: {
      get: function () {
        if (this.isContractorWorkTypes) {
          return this.request.workTypesContractor.filter(workType => !workType.hideWork && workType.standalone).sort((a, b) => a.name.localeCompare(b.name))
        } else {
          return this.request.workTypes.filter(workType => !workType.hideWork && workType.standalone).sort((a, b) => a.name.localeCompare(b.name))
        }
      },
      set: function (workTypes) {
        if (this.isContractorWorkTypes) {
          this.request.workTypesContractor = workTypes
        } else {
          this.request.workTypes = workTypes
        }
      }
    },
    workPackages: {
      get: function () {
        return this.isContractorWorkTypes ? this.request.workPackagesContractor : this.request.workPackages
      },
      set: function (workPackages) {
        if (!this.isContractorWorkTypes) {
          this.request.workPackages = workPackages
        } else {
          this.request.workPackagesContractor = workPackages
        }
      }
    },
    workTypesInitial: {
      get: function () {
        return this.isContractorWorkTypes ? this.requestInitial.workTypesContractor : this.requestInitial.workTypes
      }
    },
    workPackagesInitial: {
      get: function () {
        return this.isContractorWorkTypes ? this.requestInitial.workPackagesContractor : this.requestInitial.workPackages
      }
    },
    workTypesSearchStore: function () {
      const getTypesFn = function () {
        return this.getAvailableWorkTypes()
      }.bind(this)
      return new Store({
        itemsFn: getTypesFn,
        fullReadable: true,
        cached: false,
        searchable: true,
        alwaysShowUnselected: true
      })
    },
    workPackagesSearchStore: function () {
      const getPackagesFn = function () {
        const params = new URLSearchParams()
        if (this.request.serviceObjectType) {
          params.set('objectType', [this.request.serviceObjectType])
        }
        if (this.request.requestType) {
          params.set('requestType', this.request.requestType)
        }
        params.set('extendedResult', true)

        return axiosGet({
          // url: '/service/delta/request/getWorkPackages?' + params.toString(),
          url: '/service/delta/serviceobject/getWorkPackages?' + params.toString(),
          onSuccess: (response) => {
            response.data.result.forEach(workPackage => {
              bindTechnologicalOperationsRequiredFlags(workPackage.workTypes)
            })
            return response.data.result.map(wP => {
              const workPackage = this.workPackagesInitial.find(rWP => rWP.id === wP.id) || wP
              return {
                ...workPackage,
                _disabled: workPackage.hasAnyDoneReports
              }
            })
          },
          onFailure: 'Ошибка получения списка доступных для выбора комплексов работ',
          msgTarget: this
        })
      }.bind(this)
      return new Store({
        itemsFn: getPackagesFn,
        fullReadable: true,
        cached: false,
        searchable: true
      })
    },
    workTypesEditable: function () {
      return this.requestRoles.hasEditAccess &&
        !this.requestRoles.isContractor && // Подрядчик не может редактировать 'СОСТАВ РАБОТ' и 'СОСТАВ РАБОТ ПОДРЯДЧИКА'
        !this.requestRoles.roleRestrictedDispatcher
    },
    workPackagesEditable: function () {
      return this.workTypesEditable
    },
    showWorkPackages: function () {
      return this.taskStatus != 'BS0'
    },
    showWorkTypesSettingsBtn: function () {
      return this.requestRoles.roleDispatcherOrHigher && this.taskStatus != 'BS0'
    }
  },
  methods: {
    getAvailableWorkTypes: function () {
      const hideWorkIds = this.request.workTypes.filter(workType => workType.hideWork).map(workType => workType.id)
      return this.availableWorkTypes.filter(workType => !hideWorkIds.includes(workType.id)).map(workType => {
        return {
          ...workType,
          _disabled: this.workTypeDeselectionDisabled(workType)
        }
      })
    },
    onShowWorkTypesSettings: function () {
      const dialog = this.$d.dialog(this).show({
        maximized: true,
        contentComponent: RequestWorkTypesList,
        contentProps: {
          workTypes: this.workTypes,
          workPackages: this.workPackages,
          workTypesInitial: this.workTypesInitial,
          workPackagesInitial: this.workPackagesInitial,
          showWorkPackages: this.showWorkPackages,
          request: this.request,
          editable: false,
          setupTechnologicalOperations: true
        },
        headerLabel: this.workTypesSettingsDialogLabel,
        componentHandlers: {
          'change-work-type': (newWorkType) => {
            this.onChangeWorkType(newWorkType)
          },
          'change-work-type-in-package': (workPackageId, newWorkType) => {
            this.onChangeWorkTypeInPackage(workPackageId, newWorkType)
          },
          close: () => {
            dialog.hide()
          }
        },
        persistent: true
      })
    },
    workTypeDeselectionDisabled: function (workType) {
      const workTypeFromRequest = this.workTypes.find(wT => wT.id === workType.id)
      const isInWorkPackage = this.workPackages.some(wP => wP.workTypes.map(wT => wT.id).includes(workType.id))
      if (workTypeFromRequest) {
        return workTypeFromRequest.hasDoneReports || workTypeFromRequest.hasDonePartiallyReports || isInWorkPackage
      } else {
        return isInWorkPackage
      }
    },
    onAddWorkTypes: function () {
      const selectedWorkTypes = [...this.workTypes.map(wT => {
        return {
          ...wT,
          _disabled: this.workTypeDeselectionDisabled(wT)
        }
      })]
      const workTypesFromPackages = this.workPackages.map(wP => wP.workTypes).flat()
      workTypesFromPackages.forEach(wT => {
        if (!selectedWorkTypes.find(selWT => selWT.id === wT.id)) {
          selectedWorkTypes.push({
            ...wT,
            _disabled: true
          })
        }
      })
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentComponent: RequestWorkTypesPicker,
        contentProps: {
          store: this.workTypesSearchStore,
          headerLabel: `ВЫБОР РАБОТ${this.isContractorWorkTypes ? ' ПОДРЯДЧИКА' : ''}`,
          selectedItems: selectedWorkTypes,
          request: this.request,
          workTypes: this.workTypes,
          workPackages: this.workPackages,
          mode: 'workTypes'
        },
        componentHandlers: {
          select: (selectedItems) => {
            selectedItems.forEach(sI => {
              sI.standalone = true
            })
            this.workTypes = selectedItems.filter(wT => this.workPackages.every(wP => !wP.workTypes.map(wT => wT.id).includes(wT.id)) || this.workTypes.find(rWT => rWT.id === wT.id))
            this.$emit('changed-works', {
              newWorkTypes: selectedItems
            })
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        },
        persistent: true,
        maximized: true
      })
    },
    onAddWorkPackages: function () {
      const dialog = this.$d.dialog(this).show({
        noWrap: true,
        contentComponent: RequestWorkTypesPicker,
        contentProps: {
          store: this.workPackagesSearchStore,
          headerLabel: `ВЫБОР КОМПЛЕКСОВ РАБОТ${this.isContractorWorkTypes ? ' ПОДРЯДЧИКА' : ''}`,
          selectedItems: this.workPackages,
          request: this.request,
          mode: 'workPackages',
          workTypes: this.workTypes,
          workPackages: this.workPackages
        },
        componentHandlers: {
          select: (selectedItems) => {
            this.workPackages = selectedItems
            this.$emit('changed-works', {
              newWorkPackages: selectedItems
            })
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        },
        persistent: true,
        maximized: true
      })
    },
    onChangeWorkType: function (newWorkType) {
      const changedWorkTypeIndex = this.workTypes.findIndex(wT => wT.id === newWorkType.id)
      if (changedWorkTypeIndex !== -1) {
        this.workTypes = this.workTypes.toSpliced(changedWorkTypeIndex, 1, newWorkType)
        this.$emit('changed-works', {
          changedWorkType: newWorkType
        })
      }
    },
    onChangeWorkTypeInPackage: function (workPackageId, newWorkType) {
      const workPackages = JSON.parse(JSON.stringify(this.workPackages))
      const workPackage = workPackages.find(wP => wP.id === workPackageId)
      if (workPackage) {
        const changedWorkTypeIndex = workPackage.workTypes.findIndex(wT => wT.id === newWorkType.id)
        if (changedWorkTypeIndex !== -1) {
          workPackage.workTypes = workPackage.workTypes.toSpliced(changedWorkTypeIndex, 1, newWorkType)
          this.workPackages = workPackages
          this.$emit('changed-works', {
            changedWorkType: newWorkType,
            changedWorkPackageId: workPackageId
          })
        }
      }
    },
    onChangeWorkPackage: function (newWorkPackage) {
      const changedWorkPackageIndex = this.workPackages.findIndex(wP => wP.id === newWorkPackage.id)
      if (changedWorkPackageIndex !== -1) {
        this.workPackages = this.workPackages.toSpliced(changedWorkPackageIndex, 1, newWorkPackage)
        newWorkPackage.workTypes.forEach(workType => {
          this.$emit('changed-works', {
            changedWorkType: workType,
            changedWorkPackageId: newWorkPackage.id
          })
        })
      }
    },
    onDeleteWorkType: function (workType) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const workTypeIndex = this.workTypes.findIndex(wT => wT.id === workType.id)
            this.workPackages.forEach(wP => wP.workTypes.forEach(wT => {
              if (workType.id === wT.id) {
                wT.standalone = false
              }
            }))
            this.workTypes = this.workTypes.toSpliced(workTypeIndex, 1)
          }
        },
        header: 'Удалить?',
        warning: `Удалить работу ${workType.name}?`,
        buttons: {
          yes: 'Да',
          no: 'Нет'
        }
      })
    },
    onDeleteWorkPackage: function (workPackage) {
      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            const workPackageIndex = this.workPackages.findIndex(wP => wP.id === workPackage.id)
            this.workPackages = this.workPackages.toSpliced(workPackageIndex, 1)
          }
        },
        header: 'Удалить?',
        warning: `Удалить комплекс работ ${workPackage.name}?`,
        buttons: {
          yes: 'Да',
          no: 'Нет'
        }
      })
    },
    onResetChanges: function () {
      this.workTypes = JSON.parse(JSON.stringify(this.workTypesInitial))
      this.workPackages = JSON.parse(JSON.stringify(this.workPackagesInitial))
    }
  }
}

